import styled, { useTheme } from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';
import {
  SKYSPECS_BRAND_LOGO,
  SKYSPECS_BRAND_LOGO_WHITE,
  SKYSPECS_LOGO,
  SKYSPECS_LOGO_WHITE,
} from 'utils/constants';
import { APP_VERSION } from 'utils/env';
import { FlexContainer } from 'utils/layouts/containers';

const Footer = styled(FlexContainer).attrs({ as: 'footer' })`
  display: flex;
  flex-direction: column;
  margin: 2rem;

  img {
    box-sizing: content-box;
    width: 13rem;
    padding: 0 2em;
  }
`;

const PrivacyLink = styled.a`
  color: ${({ theme }) => theme.contrastColor};

  &:hover {
    color: ${({ theme }) => theme.teal};
  }
`;

const VersionLabel = styled.span`
  color: ${({ theme }) => theme.primaryBackgroundColor};
`;

const Line = styled.hr`
  width: 16rem;
  border-top-width: 0;
  border-color: ${({ theme }) => theme.borderColor};
  margin: 1rem 0;
`;

const GlobalFooter = () => {
  const theme = useTheme();

  return (
    <Footer>
      <img
        alt="skyspecs logo"
        src={
          theme.isHorizonGridVisualRefresh
            ? theme.themeName === Theme.Dark
              ? SKYSPECS_BRAND_LOGO_WHITE
              : SKYSPECS_BRAND_LOGO
            : theme.themeName === Theme.Dark
              ? SKYSPECS_LOGO_WHITE
              : SKYSPECS_LOGO
        }
      />
      <Line />
      <PrivacyLink target="_blank" href="https://skyspecs.com/privacy/" rel="noopener noreferrer">
        Privacy Policy
      </PrivacyLink>
      <VersionLabel>{APP_VERSION}</VersionLabel>
    </Footer>
  );
};

export default GlobalFooter;
